import type { PublishingKind } from 'utils/webrtc/types';

// stereo=1 flips libwebrtc to OPUS_APPLICATION_AUDIO, which drops libopus's 60-100Hz speech
// high-pass and lets fan/HVAC rumble through — only worth that trade at music bitrates.
const STEREO_MIN_BITRATE = 128000;

export const publisherOpusParams = ({
  quality,
  kind,
}: {
  quality: number;
  kind: PublishingKind | 'system-check';
}) => {
  // The system check never sends music, so it stays mono at any bitrate.
  const gatedStereo = kind !== 'system-check' && quality >= STEREO_MIN_BITRATE;
  // Screenshare carries music and shares the microphone's quality setting, so the gate
  // would drop it to mono at the 32000 default. Remove once screenshare has its own rate.
  const stereo = kind === 'screensharing' || gatedStereo ? 1 : 0;

  // Written as an explicit 0 rather than omitted: Firefox offers stereo=1, so Janus's answer
  // already carries it and only overwriting the value closes the gate.
  return {
    useinbandfec: 1,
    usedtx: 1,
    maxaveragebitrate: quality,
    stereo,
    'sprop-stereo': stereo,
  };
};
